import React from 'react';

const initMax = (max, rest) => {
    let m = +(max || -1);

    if (m < 0 && rest.maxLength) {
        let temp = '';
        for (let i = 0; i < rest.maxLength; i++) temp += '9';

        m = +temp;
    }

    return m;
}

const Textbox = (props) => {
    let { onChange, numeric, label, min, max, value, name, ...rest } = props,
        _min = +(min || -1),
        _max = numeric ? initMax(max, rest) : -1,
        input,
        btns = numeric
            ? (
                <React.Fragment>
                    <button type='button' onClick={(e) => handleClick('+')} tabIndex="-1">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129">
                            <path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z" />
                        </svg>
                    </button>
                    <button type='button' onClick={(e) => handleClick('-')} tabIndex="-1">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129">
                            <path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z" />
                        </svg>
                    </button>
                </React.Fragment>
            )
            : '';

    let handleClick = (operator) => {
        let n = +input.value;

        if (operator === "+") {
            n++;
            n = (_max > 0 && n > _max) ? _max : n;
        } else {
            n--;
            n = n < 0 ? 0 : (_min > 0 && n < _min) ? _min : n;
        }

        onChange({ target: { value: n, name } });
    }

    return (
        <div className="float-label">
            <label className={`float-label__label${value !== '' ? ' float-label__label-out' : ''}`}
                htmlFor={`txt${name}`}>
                {label}
            </label>
            <input
                ref={(el) => input = el}
                type='text'
                value={value}
                name={name}
                {...rest}
                id={`txt${name}`}
                onChange={onChange} />
            {btns}
        </div>
    );
};

export default Textbox;